<template>
  <div id="admissionTicket">
    <!-- <ots-main-title></ots-main-title> -->
    <div class="title">
        <p>
            <span class="routerName">准考证制作</span>
            <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
            <span class="planName">{{currentPlan.name}}</span>
            <el-dropdown trigger="click" style="margin-left: 8px;">
                <span class="el-dropdown-link">
                <img :src="planImg" alt="">
                </span>
                <template #dropdown>
                <el-dropdown-menu style="max-height:600px;height:auto;overflow-y:auto;">
                    <el-dropdown-item v-for="(item, index) in planList" :key="index" @click.native="changPlan(item)">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
                </template>
            </el-dropdown>
            <el-button class="changeDialog" size="mini" type="primary" round plain @click="templateDialogOpen">准考证标签</el-button>
            <el-button class="changeDialog" size="mini" type="primary" round @click="submitChange">确认修改</el-button>
        </p>
    </div>
    <div class="Main" :style="{width: templateWidth + 'px', height: templateHeight + 'px', background: `url(${templateBackground})`}" v-if="templateFlag">
        <!-- 改大小 -->
        <!-- @resizestop="(left, top, width, height)=>onResizstop(item, left, top, width, height)" -->
        <!-- 
          v-on:dragging="onDrag" 
          v-on:resizing="onResize" 
         -->
        <!-- 操作点 -->
        <!-- :handles="['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml']" -->
        <vue-draggable-resizable
          :resizable="false"
          @dragstop="(left, top)=>onDragstop(item, left, top)"
          v-for="(item, index) in ticketInfo"
          :key="index"
          :grid="[4, 4]"
          :x="item.x"
          :y="item.y"
          :w="item.width"
          :h="item.height"
          :parent="true"
          :active="false"
        >
          <p style="font-weight: 700;" :style="{'font-size': templateFontSize + 'px', 'line-height': templateFontSize + 'px'}" class="noUser">{{item.displayName}}&nbsp;{{item.courseName? item.courseName: ''}}</p>
        </vue-draggable-resizable>
    </div>
    <ots-custom-dialog
      :dialog.sync="templateDialog"
      title="标签选择"
      width="640px"
    >
      <template v-slot:content>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="baseInfoChoose" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="(item, index) in baseInfo" :label="item" :key="index" style="min-width: 108px;">{{item.displayName}}</el-checkbox>
        </el-checkbox-group>
      </template>
      <template v-slot:footer>
        <el-button round @click="templateDialog = false">取消</el-button>
        <el-button round type="primary" @click="submitTemplate">确定</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import { getSelectPlanFn } from '@/http/modules/examSet/examBatch'

export default {
  components: {
    draggable,
    VueDraggableResizable
  },
  data() {
    return {
      currentPlan: '',
      planImg: require('@/assets/img/courseChange.png'),
      planList: [],
      groups: [1, 2, 3, 4, 5],
      ticketInfo: [],
      templateWidth: '',
      templateHeight: '',
      templateBackground: '',
      templateFontSize: '',
      originalData: [],
      baseInfo: [],
      templateDialog: false,
      checkAll: false,
      baseInfoChoose: [],
      isIndeterminate: true,
      templateFlag: true,
      imageSize: '',
      QRSize: '',
    }
  },
  async mounted() {
    await this.initData();
    await this.getTemplate();
  },
  methods: {
    // 批次切换
    changPlan(value){
      this.currentPlan = value;
      this.getTemplate();
    },
    // 初始化数据
    async initData(){
      const {data} = await getSelectPlanFn({needAudit: 13});
      this.planList = data;
      this.currentPlan = data[0];
    },
    // 准考证模板信息
    async getTemplate() {
      let planId = this.currentPlan.id;
      const { data } = await this.$api.system.getEntranceTemplate({planId});
      this.templateWidth = data.width;
      this.templateHeight = data.height;
      this.templateBackground = data.url;
      await this.getProperty();
    },
    // 模板全量元素
    async getProperty() {
      let planId = this.currentPlan.id;
      const { data } = await this.$api.system.getEntranceProperty({planId});
      // 原始数据
      this.originalData = [...data];
      let baseInfo = [];
      let heightArr = ['entranceQrImgSize', 'imgSize', 'pdfWidth'];
      this.originalData.map(e=> {
        if ((e.value && typeof(e.value) == 'string' && heightArr.indexOf(e.name) == -1) || (!e.value && e.name.indexOf("course") == -1)) {
          baseInfo.push(e);
        }
        if (!e.value && e.name.indexOf("course") != -1) {
          baseInfo.push(e);
        }
      })
      // 勾选标签对比用
      this.baseInfo = baseInfo;
      // 勾选标签的绑定数据
      this.baseInfoChoose = [...data];
      this.baseInfoChoose = this.baseInfoChoose.filter(function(item) {
        return !(!item.value && item.name.indexOf("course") != -1) && item.value;
      })
      // 根据勾选的标签去绘制图形
      this.drawDom(this.baseInfoChoose);
    },

    // 标签绘制
    drawDom(data) {
      let newData = JSON.parse(JSON.stringify(data));
      let courseUseData = JSON.parse(JSON.stringify(data));
      let ticketInfo = [];
      // 高度的数据，另做处理
      let heightArr = ['entranceQrImgSize', 'imgSize', 'pdfWidth'];
      let courseName = ["（科目）", "（时间）", "（考场）", "（座位）"];
      // let imageSize, QRSize;
      // 照片，二维码高度获取
      newData.map(e=> {
        if (e.name == 'fontSize') {
          this.templateFontSize = e.value;
        }
        if (e.name == 'imgSize') {
          this.imageSize = e.value;
        }
        if (e.name == 'entranceQrImgSize') {
          this.QRSize = e.value;
        }
      })

      // 课程
      courseUseData.map(e=>{
        if (e.value && typeof(e.value) == 'string') {
          let v = e.value.split(",");
          if (v.length > 2) {
            e.type = e.name;
            const group1 = v.slice(0, 2).join(",");
            const group2 = v.slice(2, 4).join(",");
            const group3 = v.slice(4, 6).join(",");
            const group4 = v.slice(6, 8).join(",");
            let new_v = [group1, group2, group3, group4];
            new_v.map((item, index)=>{
              let new_e = {...e};
              new_e.value = item;
              new_e.courseName = courseName[index];
              newData.push(new_e);
            })
          }
        }
      })

      // 标准
      newData.map(e=>{
        if (e.value && typeof(e.value) == 'string' && heightArr.indexOf(e.name) == -1) {
          let v = e.value.split(",");
          if (v.length < 3) {
            let xy = e.value.split(",");
            e.x = Number(xy[0]);
            e.y = this.templateHeight - Number(xy[1]) - this.templateFontSize;
            e.width = e.type ? 86: 120;
            e.height = this.templateFontSize;
            ticketInfo.push(e);
          }
        }
      })

      // 修改 照片/二维码 宽高
      ticketInfo.map(e=>{
        if (e.name == 'imgPosition') {
          e.width = Number(this.imageSize.split(",")[0]);
          e.height = Number(this.imageSize.split(",")[1]);
          let xy = e.value.split(",");
          e.x = Number(xy[0]);
          e.y = this.templateHeight - Number(xy[1]) - e.height;
        }
        if (e.name == 'entranceQrImgPosition') {
          e.width = Number(this.QRSize.split(",")[0]);
          e.height = Number(this.QRSize.split(",")[1]);
          let xy = e.value.split(",");
          e.x = Number(xy[0]);
          e.y = this.templateHeight - Number(xy[1]) - e.height;
        }
      })
      this.ticketInfo = ticketInfo;
      this.templateFlag = true;
    },
    // change (event) {
    //   console.log('change', event)
    // },
    // start (event) {
    //   console.log('start', event)
    // },
    // end (event) {
    //   console.log('end', event, this.groups)
    // },
    // move (event, orgin) {
    //   console.log('move', event, orgin)
    // },
    // onResize: function (x, y, width, height) {
    //   this.x = x
    //   this.y = y
    //   this.width = width
    //   this.height = height
    // },
    // onDrag: function (x, y) {
    //   this.x = x
    //   this.y = y
    // },
    // onResizstop(item, x, y, width, height){
    //   item.x = x;
    //   item.y = y;
    //   item.width = width;
    //   item.height = height;
    //   this.$nextTick(()=>{})
    // },
    onDragstop(item, x , y){
      item.x = x
      item.y = y
    },
    submitTemplate() {
      this.templateFlag = false;
      // 课程处理
      this.baseInfoChoose.map(e=>{
        if (!e.value && e.name.indexOf('course') !== -1) {
          e.value = `100, ${this.templateHeight - 80}, 200, ${this.templateHeight - 80}, 300, ${this.templateHeight - 80}, 400, ${this.templateHeight - 80}`
        } 
        if (!e.value) {
          e.value = `100, ${this.templateHeight - 60}`;
        }
      })
      this.$nextTick(() => {
        this.drawDom(this.baseInfoChoose);
      })
      this.templateDialog = false;
    },
    templateDialogOpen() {
      this.templateDialog = true;
    },
    // 全选
    handleCheckAllChange(val) {
      this.baseInfoChoose = val ? this.baseInfo : [];
      this.isIndeterminate = false;
    },
    // 勾选
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.baseInfo.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.baseInfo.length;
    },
    // 确认修改，修改数据与原始数据比对处理
    async submitChange() {
      let submitData = [];
      let courseData = [];
      let position = {};
      // (1) 未使用数据处理
      this.originalData.map((e,i) => {
        if (!e.value || typeof(e.value) != 'string' || e.name == 'entranceQrImgSize' || e.name == 'imgSize') {
          submitData.push(e);
        }
        if (e.value && typeof(e.value) == 'string' && e.value.split(",").length > 2) {
          courseData.push(e);
        }
        // if (e.name.indexOf('course') !== -1) {
        //   courseData.push(e);
        // }
      })
      // (2) 普通标签处理
      this.ticketInfo.map(e => {
        if (!e.type) {
          let value = [e.x, this.templateHeight - e.y - e.height].join(",");
          let item = {
            displayName: e.displayName,
            name: e.name,
            value
          }
          submitData.push(item);
        }
      })
      // (3) 课程标签处理
      courseData.map((c,i) => {
        let sizeArr = [];
        this.ticketInfo.map(t => {
          if (c.name == t.type) {
            let value = [t.x, this.templateHeight - t.y - t.height];
            sizeArr = sizeArr.concat(value);
          }
        })
        c.value = sizeArr.join(",");
        submitData.push(c);
      })
      // (4) 未选中的课程，数值清空
      let courseChoose = [];
      this.baseInfoChoose.map(e=>{
        if (e.name.indexOf("course") !== -1) {
          courseChoose.push(e.name);
        }
      })
      submitData.map(e => {
        if (e.name.indexOf("course") !== -1 && courseChoose.indexOf(e.name) == -1) {
          e.value = '';
        }
      })

      submitData.map(s => {
        position[s.name] = s.value;
      })

      position.pdfWidth = this.templateWidth;

      let params = {
        position: JSON.stringify(position)
      }

      const { code } = await this.$api.system.saveEntrancePrintPosition(params);
      if (code == 1) {
        this.$message.success("修改成功！");
      }
    }
  }
}
</script>

<style scoped lang="less">
#admissionTicket {
  .title {
    height: 32px;
    p {
      display: flex;
      align-items: center;
        .routerName {
            font-size: 14px;
            color: #9299A6;
        }
        .planName {
            font-size: 24px;
            font-weight: 500;
            color: #2D2F33;
        }
        .el-dropdown-link {
            cursor: pointer;
            color: var(--el-color-primary);
            display: flex;
            align-items: center;
        }
    }
    .changeDialog {
      margin-left: 24px;
    }
  }
  .Main {
    position: relative;
    margin-top: 16px;
    border: 2px dashed #2D2F33;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .noUser {
    user-select: none;
  }
}
</style>